import { comparatorBy } from "diagnostics-lib/comparator";

export function getQuantitySelectorLists<T extends { id: string; name: string }>(
  visibleQuantities: readonly T[],
  searchedQuantities: readonly T[],
  selectedQuantities: readonly { quantity: { id: string } }[],
) {
  const selectedIds = new Set(selectedQuantities.map(({ quantity }) => quantity.id));

  return {
    selected: visibleQuantities
      .filter(quantity => selectedIds.has(quantity.id))
      .sort(comparatorBy("name")),
    results: [...searchedQuantities],
  };
}
